// @flow
import {
	LOGIN,
	LOGOUT,
	CHECK_SESSION,
	RESET_CHECK_SESSION,
	SESSION_CHECKED_SUCCESS,
	SESSION_CHECKED_ERROR,
	LOGIN_ERROR,
	SET_SESSION_ID,
	INITIATE_LOGIN,
	LOGIN_SUCCESS,
	REQUEST_OTP,
	INITIATE_REQUEST_OTP,
	REQUEST_OTP_SUCCESS,
	REQUEST_OTP_ERROR,
	RESET_OTP_REQUEST,
	SETTING_MPIN,
	SETTING_MPIN_SUCCESS,
	SETTING_MPIN_ERROR,
	VALIDATE_OTP,
	RESET_SESSION,
	TOKEN_AUTHENTICATE,
	TOGGLE_SIGNUP_DLG,
	FETCH_SESSION_ID,
	FETCH_SESSION_ID_SUCCESS,
	UPDATE_SESSION_DATA,
	CANCEL_FETCH_SESSION_ID,
} from './types';
import type { Action } from './types';

export const login = (mobile: string, mpin: string): Action => ({
	type: LOGIN,
	payload: { mobile, mpin },
});

export const initiateLogin = (): Action => ({
	type: INITIATE_LOGIN,
});

export const loginError = (error: any): Action => ({
	type: LOGIN_ERROR,
	payload: error,
});

export const loginSuccess = (sessionId: string): Action => ({
	type: LOGIN_SUCCESS,
	payload: sessionId,
});

export const logout = (sessionId: string): Action => ({
	type: LOGOUT,
  payload: sessionId,
});

export const checkSession = (sessionId: string): Action => ({
	type: CHECK_SESSION,
	payload: sessionId,
});

export const resetCheckSession = (): Action => ({
	type: RESET_CHECK_SESSION,
});

export const checkSessionSuccess = (): Action => ({
	type: SESSION_CHECKED_SUCCESS,
});

export const checkSessionError = (error: any): Action => ({
	type: SESSION_CHECKED_ERROR,
	payload: error,
});

export const setSessionId = (sessionId: string): Action => ({
	type: SET_SESSION_ID,
	payload: sessionId,
});

export const requestOTP = (mobile: string, type: 'SIGNUP' | 'FORGOT_MPIN'): Action => ({
	type: REQUEST_OTP,
	payload: { mobile, type },
});

export const initRequestOTP = (): Action => ({
	type: INITIATE_REQUEST_OTP,
});

export const requestOTPSuccess = (): Action => ({
	type: REQUEST_OTP_SUCCESS,
});

export const requestOTPError = (error: Error): Action => ({
	type: REQUEST_OTP_ERROR,
	payload: error,
});

export const resetOTPRequest = (error: Error): Action => ({
	type: RESET_OTP_REQUEST,
	payload: error,
});
/*
export const checkOfferRequest = (offer_id:String): Action => ({
	type: CHECK_OFFER_REQUEST,
	payload:offer_id,
});*/


export const setMpin = (mpin: string, mobile: string): Action => ({
	type: SETTING_MPIN,
	payload: { mpin, mobile },
});

export const setMpinSuccess = (): Action => ({
	type: SETTING_MPIN_SUCCESS,
});

export const setMpinError = (error: Error): Action => ({
	type: SETTING_MPIN_ERROR,
	payload: error,
});

export const validateOTP = (
	mobile: string,
	otp: string,
	type: 'SIGNUP' | 'FORGOT_MPIN',
	sessionId: string,
	userOfferId:string
): Action => ({
	type: VALIDATE_OTP,
	payload: { mobile, otp, type, sessionId, userOfferId},
});

export const resetSession = (): Action => ({
	type: RESET_SESSION,
});

export const tokenAuth = (token: string, sessionId: string): Action => ({
	type: TOKEN_AUTHENTICATE,
	payload: { token, sessionId },
});

export const toggleSignupDlg = (payload: boolean): Action => ({
	type: TOGGLE_SIGNUP_DLG,
	payload,
});

export const fetchSessionId = (sessionId: string): Action => ({
	type: FETCH_SESSION_ID,
	payload: sessionId,
});

export const fetchSessionIdSuccess = (sessionId: string): Action => ({
	type: FETCH_SESSION_ID_SUCCESS,
	payload: { sessionId },
});

export const cancelFetchSessionId = (): Action => ({
	type: CANCEL_FETCH_SESSION_ID,
});

export const updateSessionData = (data: { [key: string]: any }, sessionId: string): Action => ({
	type: UPDATE_SESSION_DATA,
	payload: { data, sessionId },
});